import { useMemo } from "react"
import type { LucideIcon } from "lucide-react"
import { Home } from "lucide-react"

import { usePermissions } from "@/hooks/usePermissions"
import { isModuleEnabled } from "@/lib/modules"
import { modulosVisiveis } from "@/lib/modulos"

export interface NavItem {
  label: string
  to: string
  icon: LucideIcon
}

export interface NavGroup {
  label: string
  icon: LucideIcon | null
  items: NavItem[]
}

export function useNavGroups(): NavGroup[] {
  const { has } = usePermissions()

  return useMemo(() => {
    const geral: NavGroup = {
      label: "Geral",
      icon: null,
      items: [{ label: "Início", to: "/", icon: Home }],
    }
    const secoes = modulosVisiveis(has, isModuleEnabled).map<NavGroup>((modulo) => ({
      label: modulo.nome,
      icon: modulo.icon,
      items: modulo.itens.map((item) => ({ label: item.label, to: item.to, icon: item.icon })),
    }))
    return [geral, ...secoes]
  }, [has])
}
